import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { validateEmail } from "../../../commonData";
import { BasicContext } from "../../../App";
import { postMethod } from "../../../requests";
import Email from "../../../components/inputs/Email";
import UserRolesDropdown from "../../../components/dropdowns/UserRolesDropdown";
import { Checkbox } from "semantic-ui-react";
import GoBackBtn from "../../../components/buttons/GoBackBtn";

const AddUser = () => {
    const { t } = useTranslation();
    const { checkServerData, changeView, setAlerts } = useContext(BasicContext);
    const [user, setUser] = useState({ email: "", name: "", surname: "", ig: "", address: "", note: "", phone: "", userRoles: [], longBooking: false });
    const [blockForm, setBlockForm] = useState(false);

    useEffect(() => {
        if (user.userRoles !== "STUDENT") setUser({ ...user, longBooking: false });
        // eslint-disable-next-line
    }, [user.userRoles]);

    const addNewUser = async () => {
        const res = await postMethod("/add-user", { user: user });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t("success.userAdded"), fading: 1500, id: "added" }]);
            changeView({ nav: "users", sub: "userDetails", params: { userID: res.data.userID } });
        } else setBlockForm(false);
    };

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];

        if (user.email.length === 0 || !user.email.replace(/\s+/, "")) {
            $("#addUserFormEmail").addClass("is-invalid");
            errors.push(t("error.emptyEmail"));
        } else {
            if (!validateEmail(user.email)) {
                $("#addUserFormEmail").addClass("is-invalid");
                errors.push(t("error.invalidEmail"));
            }
        }

        if (user.name.length === 0 || !user.name.replace(/\s+/, "")) {
            $("#addUserFormname").addClass("is-invalid");
            errors.push(t("error.emptyName"));
        } else if (user.name.length > 50) {
            $("#addUserFormname").addClass("is-invalid");
            errors.push(t("error.userNameTooLong"));
        }

        if (user.surname.length === 0 || !user.surname.replace(/\s+/, "")) {
            $("#addUserFormsurname").addClass("is-invalid");
            errors.push(t("error.emptySurname"));
        } else if (user.surname.length > 50) {
            $("#addUserFormsurname").addClass("is-invalid");
            errors.push(t("error.userSurnameTooLong"));
        }

        if (user.phone.length === 0 || !user.phone.replace(/\s+/, "")) {
            $("#addUserFormphone").addClass("is-invalid");
            errors.push(t("error.emptyPhone"));
        } else if (!/^(\+48\s?)?(\d{3}\s?\d{3}\s?\d{3})$/.test(user.phone)) {
            $("#addUserFormphone").addClass("is-invalid");
            errors.push(t("error.invalidPhone"));
        } else if (user.phone.length > 30) {
            $("#addUserFormphone").addClass("is-invalid");
            errors.push(t("error.userPhoneTooLong"));
        }

        if (user.ig.length > 0 && !/^(?!.*\.\.)(?!.*\.$)(?!\d+$)[a-zA-Z0-9._]{1,30}$/.test(user.ig)) {
            $("#addUserFormig").addClass("is-invalid");
            errors.push(t("error.invalidIgNick"));
        } else if (user.ig.length > 0 && user.ig.length > 30) {
            $("#addUserFormig").addClass("is-invalid");
            errors.push(t("error.userInstagramTooLong"));
        }

        if (user.note.length > 0 && !user.note.replace(/\s+/, "")) {
            $("#addUserFormNote").addClass("is-invalid");
            errors.push(t("error.invalidUserFormNote"));
        } else if (user.note.length > 0 && user.note.length > 255) {
            $("#addUserFormNote").addClass("is-invalid");
            errors.push(t("error.userNoteTooLong"));
        }

        if (user.address.length > 0 && !user.address.replace(/\s+/, "")) {
            $("#addUserFormAddress").addClass("is-invalid");
            errors.push(t("error.invalidAddress"));
        } else if (user.address.length > 0 && user.address.length > 255) {
            $("#addUserFormAddress").addClass("is-invalid");
            errors.push(t("error.userAddressTooLong"));
        }

        if (user.userRoles.length === 0) {
            $("#addUserFormUserRole").addClass("is-invalid");
            errors.push(t("error.noSelectedUserRole"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            setAlerts([{ variant: "info", message: t("info.creatingNewUser") }]);
            setBlockForm(true);
            addNewUser();
        }
    };

    const textInputs = [
        { name: "name", req: true },
        { name: "surname", req: true },
        { name: "phone", req: true },
        { name: "ig", req: false },
    ];

    const autoResize = (textarea) => {
        textarea.style.height = "auto"; // Resetowanie wysokości
        textarea.style.height = `${textarea.scrollHeight}px`; // Ustawienie wysokości na podstawie zawartości
    };

    const resize = (area) => {
        autoResize(area);
        area.addEventListener("input", function () {
            autoResize(this);
        });
    };

    useEffect(() => {
        resize(document.getElementById("addUserFormNote"));
        resize(document.getElementById("addUserFormAddress"));
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <GoBackBtn />
            <Container fluid="lg">
                <Row>
                    <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                        <h1 className="h4 d-inline-block m-0 pt-2">{t("users.addUser")}</h1>
                    </Col>
                    <Col xs={12} className="px-4 mb-4 px-lg-2 ">
                        <Form onSubmit={checkValidation} autoComplete="off">
                            <input type="text" name="prevent-autofill" id="prevent-autofill" style={{ display: "none" }} autoComplete="off" />
                            <Row>
                                <Col xs={12} lg={4}>
                                    <Email
                                        id="addUserFormEmail"
                                        onChange={(e) => {
                                            $(`#addUserFormEmail`).removeClass("is-invalid");
                                            setUser({ ...user, email: e.target.value });
                                        }}
                                        blockForm={blockForm}
                                        value={user.email}
                                        autoComplete="off"
                                    />
                                </Col>
                                {textInputs.map((e, i) => (
                                    <Col xs={12} lg={e.name === "phone" || e.name === "ig" ? 3 : 4}>
                                        <Form.Group key={i} className="mb-3" controlId={`addUserForm${e.name}`}>
                                            <Form.Label className="w-100">
                                                {t(`addUserForm.${e.name}`)} {e.req && <span className="text-danger">*</span>}
                                            </Form.Label>
                                            <Form.Control
                                                value={user[e.name]}
                                                onChange={(el) => {
                                                    $(`#addUserForm${e.name}`).removeClass("is-invalid");
                                                    setUser({ ...user, [e.name]: el.target.value });
                                                }}
                                                placeholder={t(`addUserForm.${e.name}Placeholder`)}
                                                type="text"
                                                disabled={blockForm}
                                            />
                                        </Form.Group>
                                    </Col>
                                ))}
                                <Col xs={12} lg={4}>
                                    <Form.Group className="mb-3" controlId={`addUserFormAddress`}>
                                        <Form.Label className="w-100">{t(`addUserForm.address`)}</Form.Label>
                                        <Form.Control
                                            value={user.address}
                                            onChange={(el) => {
                                                $("#addUserFormAddress").removeClass("is-invalid");
                                                setUser({ ...user, address: el.target.value });
                                            }}
                                            placeholder={t(`addUserForm.addressPlaceholder`)}
                                            as="textarea"
                                            disabled={blockForm}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={6}>
                                    <UserRolesDropdown
                                        classN="mb-3"
                                        req
                                        onChange={(v) => {
                                            setUser({ ...user, userRoles: v });
                                            $("#addUserFormUserRole").removeClass("is-invalid");
                                        }}
                                        value={user.userRoles}
                                        multiple
                                        id="addUserFormUserRole"
                                    />
                                </Col>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId={`addUserFormNote`}>
                                        <Form.Label className="w-100">{t(`addUserForm.note`)}</Form.Label>
                                        <Form.Control
                                            value={user.note}
                                            onChange={(el) => {
                                                $("#addUserFormNote").removeClass("is-invalid");
                                                setUser({ ...user, note: el.target.value });
                                            }}
                                            placeholder={t(`addUserForm.notePlaceholder`)}
                                            as="textarea"
                                            disabled={blockForm}
                                        />
                                    </Form.Group>
                                </Col>
                                {user.userRoles.length > 0 && (
                                    <Col xs={12}>
                                        {user.userRoles.filter((e) => e === "STUDENT").length === 1 && (
                                            <Form.Group className="mb-3" controlId={`addUserFormLongBooking`}>
                                                <Checkbox
                                                    label={<label className="form-label">{t("addUserForm.longBooking")}</label>}
                                                    id="addUserFormLongBooking"
                                                    checked={user.longBooking}
                                                    onChange={() => {
                                                        setUser({ ...user, longBooking: !user.longBooking });
                                                    }}
                                                />
                                            </Form.Group>
                                        )}
                                    </Col>
                                )}
                            </Row>
                            <Row className="sticky-bottom bg-light-primary">
                                <Col xs={6}>
                                    <Button variant="primary" className="px-4 mt-4 mb-4" type="submit" disabled={blockForm}>
                                        {t("create")}
                                    </Button>
                                </Col>
                                <Col xs={6} className="text-end">
                                    <Button variant="outline-secondary" className="px-4 mt-4 mb-4" onClick={() => changeView({ nav: "users", sub: "usersList" })}>
                                        {t("cancel")}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default AddUser;
